<script lang="ts">
	import ListItem from "./ListItem.svelte";

	export let max: number = Infinity;
	export let values: string[] = [];

	let newValue: string = null;

	let newInput: HTMLInputElement;

	function addEntry(value: string) {
		if (!value) return;
		if (value.indexOf('://') < 0) {
			value = `https://${value}`;
		}
		values = values.concat([value]);
	}

	function focusNewInput() {
		setTimeout(() => {
			if (newInput) {
				newInput.focus();
			}
		});
	}

	function lastChanged() {
		addEntry(newValue);
		newValue = null;
		focusNewInput();
	}

	function inputChanged() {
		values = values.filter(v => v);
	}

	function pasted(e: ClipboardEvent) {
		let item = e.clipboardData?.items?.[0];
		for (let i of e.clipboardData?.items) {
			if (i.type === 'text/plain') { // prefer plain text
				item = i;
			}
		}
		item?.getAsString(s => {
			const entries = s.split(/[\n\t]+/);
			entries.forEach(e => addEntry(e));

			newValue = null;
			focusNewInput();
		});
	}
</script>

{#each values as value, index}
	<ListItem on:remove={() => values = values.filter((_, i) => i !== index)} name={value}>
		<input title="URL {index+1}"  class="finished-input" type="url" bind:value on:change={inputChanged}>
	</ListItem>
{/each}
{#if values.length < max}
	<input title="Insert Url" bind:this={newInput} type="url" bind:value={newValue} on:change={lastChanged} on:paste={pasted}>
{/if}
<style>
	input {
		background: white;
		border: 2px dashed black;
		width: 100%;
		border-radius:12px;
		margin-bottom: 2px;
		padding:5px;
	}
	input.finished-input {
		all: unset;
		width: 100%;
	}
</style>
